import React, { useEffect, useState, useMemo } from 'react';
import './ShopBasketAdd.css';
import './styles-exist.css';

import Modal from '../../../Components/Modal/Modal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { toast } from 'react-toastify';
import { FaCircleCheck } from "react-icons/fa6";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link } from 'react-router-dom';
import { SlBasket } from "react-icons/sl";
import { HiOutlineTrash } from "react-icons/hi2"; // آیکون سطل زباله
import config from '../../../config';
import Sheet from "react-modal-sheet";
import { FiImage } from "react-icons/fi";
import TelegramSafeArea from '../../../Components/TelegramSafeArea';
import { usePost } from '../../../hooks/usePost';

const configs = [
    { stiffness: 300, damping: 30, mass: 0.2 },
    { stiffness: 150, damping: 20, mass: 1 }
];

const themeColors = [
    { id: 1, title: "قرمز", code: "#D32F2F", text: "#000" },
    { id: 2, title: "سبز", code: "#388E3C", text: "#000" },
    { id: 3, title: "زرد", code: "#FBC02D", text: "#000" },
    { id: 4, title: "صورتی", code: "#C2185B", text: "#000" },
    { id: 5, title: "آبی", code: "#1976D2", text: "#000" },
    { id: 6, title: "بنفش", code: "#7B1FA2", text: "#000" },
    { id: 7, title: "نارنجی", code: "#E64A19", text: "#000" },
    { id: 8, title: "طوسی", code: "#212121", text: "#000" },
];

function ShopBasketAdd({ commodityId, storeId, store: propStore, onAdd, fn_close, isShow, badge }) {
    const [isOpenAdd, setIsOpenAdd] = useState(false);
    const [selectedP1, setSelectedP1] = useState(null);
    const [selectedP2, setSelectedP2] = useState(null);
    const [current, setCurrent] = useState({});

    const { data: fetchedData, loading: isFetching } = usePost(
        commodityId ? `commodity/search/byId` : null,
        { commodity_id: commodityId, business_id: storeId || propStore?.id || -1 }
    );

    const commodity = useMemo(() => {
        if (!fetchedData) return null;
        if (Array.isArray(fetchedData)) return fetchedData[0];
        if (fetchedData.data && Array.isArray(fetchedData.data)) return fetchedData.data[0];
        if (fetchedData.data) return fetchedData.data;
        return fetchedData;
    }, [fetchedData]);

    // منبع معتبر تم: ابتدا استیت فروشگاه والد، سپس بیزینس متصل به کالا، سپس سشن
    const activeStore = useMemo(() => {
        if (propStore) return propStore;
        if (commodity?.business) return commodity.business;
        try {
            return JSON.parse(sessionStorage.getItem("store")) ?? null;
        } catch {
            return null;
        }
    }, [propStore, commodity]);

    // محاسبه آنی رنگ‌های تم بدون تاخیر
    const { bgLight, color, activeColorCode } = useMemo(() => {
        const themeJson = activeStore?.theme_json || commodity?.business?.theme_json;
        if (!themeJson) {
            return { bgLight: null, color: '#000', activeColorCode: '#1976D2' };
        }
        try {
            const themeObj = typeof themeJson === 'string' ? JSON.parse(themeJson) : themeJson;
            const colorId = themeObj.color_id || 1;
            const activeColor = themeColors.find(c => c.id === parseInt(colorId)) || themeColors[0];
            return {
                bgLight: `${activeColor.code}1A`,
                color: activeColor.text || '#000',
                activeColorCode: activeColor.code
            };
        } catch {
            return { bgLight: null, color: '#000', activeColorCode: '#1976D2' };
        }
    }, [activeStore, commodity]);

    const isLoading = isFetching || !commodity;
    const [configSheet] = useState(configs[0]);
    const [isOpenExist, setIsOpenExist] = useState(false);

    const [baskets, setBaskets] = useState(() => {
        try {
            return localStorage.getItem("baskets") ? JSON.parse(localStorage.getItem("baskets")) : [];
        } catch {
            return [];
        }
    });

    const fn_remove_basket = (id) => {
        const newBaskets = baskets.filter(basket => basket.id != id);
        localStorage.setItem("baskets", JSON.stringify(newBaskets));
        setBaskets(newBaskets);
    };

    const eventToggleAdd = () => {
        fn_close();
    };

    const handleInstagramClick = (e) => {
        e.stopPropagation();
        const url = commodity?.instagram_post_url;
        if (!url) return;

        const targetUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;

        if (window.Telegram?.WebApp?.openLink) {
            window.Telegram.WebApp.openLink(targetUrl);
        } else {
            window.open(targetUrl, '_blank', 'noopener,noreferrer');
        }
    };

    const galleryImages = useMemo(() => {
        if (!commodity) return [];
        const images = [];
        if (commodity.image_path) {
            images.push(commodity.image_path);
        }
        if (commodity.gallery_path && Array.isArray(commodity.gallery_path)) {
            images.push(...commodity.gallery_path);
        }
        return images;
    }, [commodity]);

    const { variants: allVariants, titles: propTitles } = useMemo(() => {
        let variants = [];
        let titles = { title1: "ویژگی اول", title2: "ویژگی دوم" };

        if (commodity && commodity.properties) {
            try {
                const parsedProps = typeof commodity.properties === 'string'
                    ? JSON.parse(commodity.properties)
                    : commodity.properties;

                if (parsedProps && parsedProps.propertyData) {
                    const p1Keys = Object.keys(parsedProps.propertyData);
                    titles = {
                        title1: parsedProps.propertiesData?.title1 || "ویژگی اول",
                        title2: parsedProps.propertiesData?.title2 || "ویژگی دوم"
                    };

                    p1Keys.forEach(p1 => {
                        const items = parsedProps.propertyData[p1];
                        if (Array.isArray(items)) {
                            items.forEach(item => {
                                if (item.active && item.rawPrice) {
                                    variants.push({ ...item, p1Name: p1 });
                                }
                            });
                        }
                    });
                } else if (Array.isArray(parsedProps)) {
                    variants = parsedProps;
                }
            } catch (e) {
                console.error("Error parsing properties", e);
            }
        }
        return { variants, titles };
    }, [commodity]);

    useEffect(() => {
        if (allVariants.length > 0 && !selectedP1) {
            const firstItem = allVariants[0];
            setSelectedP1(firstItem.p1Name);
            setSelectedP2(firstItem.name);
            setCurrent(firstItem);
        }
    }, [allVariants]);

    useEffect(() => {
        if (selectedP1 && selectedP2 && allVariants.length > 0) {
            const found = allVariants.find(v => v.p1Name === selectedP1 && v.name === selectedP2);
            if (found) {
                setCurrent(found);
            } else {
                const firstForP1 = allVariants.find(v => v.p1Name === selectedP1);
                if (firstForP1) {
                    setSelectedP2(firstForP1.name);
                    setCurrent(firstForP1);
                }
            }
        }
    }, [selectedP1, selectedP2, allVariants]);

    function handleIncrement() {
        if (!commodity) return;
        const maxStock = parseInt(current.stock) || 0;
        let currentQuantity = 0;

        let currentBaskets = baskets;
        try {
            const localBasketsData = localStorage.getItem('baskets');
            if (localBasketsData) {
                currentBaskets = JSON.parse(localBasketsData);
            }
        } catch (e) {
            console.error("Error parsing baskets", e);
        }

        currentBaskets.forEach(basketObj => {
            if (basketObj.cartItems && basketObj.cartItems.length > 0) {
                const existingItem = basketObj.cartItems.find(item =>
                    item.id === commodity.id && item.variant_id === current.id
                );
                if (existingItem) {
                    currentQuantity = existingItem.quantity || 0;
                }
            }
        });

        if (currentQuantity >= maxStock) {
            toast.error(`حداکثر موجودی این کالا در انبار (${maxStock} عدد) در سبد شماست!`);
            return;
        }

        if ((currentBaskets.filter(basket => basket.id != activeStore?.id).length >= 3)) {
            setIsOpenExist(true);
        } else {
            onAdd({
                product: commodity,
                current: current,
                uniqueKey: `${commodity.id}-${current.id}`
            });
            setIsOpenAdd(true);
        }
    }

    const firstLevelData = useMemo(() => {
        const uniqueP1 = [...new Set(allVariants.map(v => v.p1Name))].filter(Boolean);
        return uniqueP1.map((name, index) => ({ id: index, title: name }));
    }, [allVariants]);

    const secondLevelData = useMemo(() => {
        if (!selectedP1) return [];
        return allVariants
            .filter(v => v.p1Name === selectedP1)
            .map(v => ({ id: v.id, title: v.name, price: v.price }));
    }, [allVariants, selectedP1]);

    const isDummyName = (name) => {
        if (!name) return true;
        const n = name.toString().trim();
        const dummies = ['', '-', '_', 'پیش فرض', 'بدون ویژگی', 'بدون متغیر', 'عادی', 'نامشخص', 'نام خصوصیت اول', 'نام خصوصیت دوم', 'کالای اصلی'];
        return dummies.includes(n);
    };

    const showFirstGroup = firstLevelData.length > 0 && (firstLevelData.length > 1 || !isDummyName(firstLevelData[0].title));
    const showSecondGroup = secondLevelData.length > 0 && (secondLevelData.length > 1 || (!isDummyName(secondLevelData[0].title) && secondLevelData[0].title !== selectedP1));

    const extraTitleText = commodity?.extraTitle ? commodity.extraTitle.toString().trim() : '';
    const hasExtraTitle = extraTitleText.length > 0;
    const hasProperties = showFirstGroup || showSecondGroup;
    const hasDescription = commodity?.description ? commodity.description.toString().trim().length > 0 : false;

    return (
        <div>
            {isOpenExist && <Sheet
                color='red'
                springConfig={configSheet}
                isOpen={isOpenExist}
                onClose={() => setIsOpenExist(false)}
                snapPoints={[600, 400, 0, 0]}
                initialSnap={0}
            >
                <Sheet.Container>
                    <Sheet.Content>
                        <div className='shop-basket-exist'>
                            <div className="header">
                                <span>مدیریت سبد خرید فروشگاه ها</span>
                            </div>
                            <div className="description">
                                <span>ظرفیت سبد خرید تکمیل گردیده...</span>
                            </div>
                            <div className="wrraper-exist-store">
                                {baskets.length > 0 && baskets.map((item) => (
                                    <div className="store-box" key={item.id}>
                                        <div className="store-img">
                                            <img src={`${config.api.imageURL}/${item.store.image_logo}`} alt="logo" />
                                        </div>
                                        <div className="store-context">
                                            {/* جایگزین شده با react-icons */}
                                            <div className="remove">
                                                <HiOutlineTrash 
                                                    size={22} 
                                                    color="#d32f2f" 
                                                    style={{ cursor: 'pointer', transition: 'transform 0.15s ease' }}
                                                    onClick={() => fn_remove_basket(item.id)} 
                                                    title="حذف فروشگاه از سبد"
                                                />
                                            </div>
                                            <div className="title"> {item.store.title} </div>
                                            <div className="title"> تعداد کالا: {item.cartItems.reduce((o, c) => o + c.quantity, 0) ?? 0} عدد</div>
                                        </div>
                                    </div>
                                ))}
                                <div className="wrraper-go-to-basket">
                                    <div className="go-to-basket" onClick={() => setIsOpenExist(false)}>
                                        بازگشت به سبد خرید
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>}

            {!isOpenExist && <Modal eventToggle={eventToggleAdd} isOpen={isShow} locked={true} fullscreen={true} isLoading={isLoading} >
                <div className="ShopBasketAdd" style={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: bgLight, overflow: 'hidden' }}>

                    <TelegramSafeArea
                        style={{
                            flexShrink: 0,
                            backgroundColor: "transparent",
                            color: color,
                            zIndex: 10
                        }}
                    >
                        <div
                            className="safe-area-title"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '1.3',
                                padding: '10px 0',
                            }}
                        >
                            {(commodity?.business?.title || activeStore?.title) ? (
                                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                    {commodity?.business?.title || activeStore?.title}
                                </span>
                            ) : (
                                <div className="skeleton-shimmer" style={{ width: '80px', height: '14px', borderRadius: '4px', marginBottom: '4px' }}></div>
                            )}

                            {(commodity?.business?.message || activeStore?.message) ? (
                                <span style={{ fontSize: '12px', opacity: 0.85 }}>
                                    {commodity?.business?.message || activeStore?.message}
                                </span>
                            ) : (!commodity?.business && !activeStore) ? (
                                <div className="skeleton-shimmer" style={{ width: '120px', height: '10px', borderRadius: '4px' }}></div>
                            ) : null}
                        </div>
                    </TelegramSafeArea>

                    <div className="topbar" style={{ flexShrink: 0, zIndex: 10 }}>
                        <div className="bannerShopBasketAdd" style={{ background: "transparent" }}>
                            <div className="header-title" style={{ fontFamily: "vazir", fontSize: '1.1rem', whiteSpace: 'nowrap' }}>
                                جزئیات محصول
                            </div>
                            <div className="back" onClick={fn_close}>
                                <div className="btn-back"><IoMdArrowRoundBack size={"25px"} /></div>
                                <div className='back-title'>بازگشت</div>
                            </div>

                            <Link to={(badge ?? 0) > 0 ? "/ShopBasket" : "#"}>
                                <div className="btnShop basket">
                                    <SlBasket size={"25px"} />
                                    <span style={{ color: "green", marginTop: "0px" }}>خرید</span>
                                    <span className='counter-basket'>{badge ?? 0}</span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    {isLoading ? (
                        <>
                            <div className="body-ShopBasketAdd">
                                <div className="wrraper-ShopBasketAdd">
                                    <div className="skeleton-shimmer skeleton-gallery"></div>

                                    <div className="commodity">
                                        <div className="skeleton-shimmer skeleton-title-modal"></div>
                                        <div className="extraTitle">
                                            <div className="skeleton-shimmer skeleton-subtitle-modal"></div>
                                            <div className="skeleton-property-group">
                                                <div className="skeleton-shimmer skeleton-property-item"></div>
                                                <div className="skeleton-shimmer skeleton-property-item"></div>
                                            </div>
                                            <div className="skeleton-shimmer skeleton-subtitle-modal" style={{ width: '40%' }}></div>
                                            <div className="skeleton-property-group">
                                                <div className="skeleton-shimmer skeleton-property-item"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="price-add-basket" style={{ flexShrink: 0 }}>
                                <div className="skeleton-shimmer skeleton-price-section"></div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="body-ShopBasketAdd">
                                <div className="wrraper-ShopBasketAdd">
                                    <div className="swiper-ShopBasketAdd">
                                        {galleryImages.length > 0 ? (
                                            <Swiper
                                                modules={[Navigation, Pagination, A11y]}
                                                spaceBetween={10}
                                                slidesPerView={1}
                                                pagination={{ dynamicBullets: true, clickable: true }}
                                                className='swiper'
                                            >
                                                {galleryImages.map((item, idx) => (
                                                    <SwiperSlide key={idx} className="swipercommodity-slide">
                                                        <div className="swipercommodity-image">
                                                            <img
                                                                src={`${config.api.imageURL}/${item}`}
                                                                alt={commodity.title || "Product"}
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        ) : (
                                            <div className="swiper-empty-placeholder">
                                                <FiImage size="40px" style={{ marginBottom: '10px' }} />
                                                <span>تصویری برای این کالا ثبت نشده است</span>
                                            </div>
                                        )}

                                        {commodity?.instagram_post_url && (
                                            <div className="instagram-post" onClick={handleInstagramClick}>
                                                <img src={process.env.PUBLIC_URL + '/images/instagram.png'} alt="instagram" />
                                                <span>مشاهده در اینستاگرام</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="commodity">
                                        <div className="title">
                                            {(commodity.title ?? '').substring(0, 70)}
                                        </div>

                                        {(hasExtraTitle || hasProperties) && (
                                            <div className="extraTitle">
                                                {hasExtraTitle && (
                                                    <span>{extraTitleText.substring(0, 50)}</span>
                                                )}

                                                {hasProperties && (
                                                    <div className='propertiesGroup'>
                                                        {showFirstGroup &&
                                                            <div className="group first">
                                                                <div className='title'>
                                                                    {propTitles.title1} : {selectedP1}
                                                                </div>
                                                                <div className='itemsSelect'>
                                                                    {firstLevelData.map((item) => (
                                                                        <div
                                                                            key={item.title}
                                                                            className={`itemSelect${selectedP1 === item.title ? " choice" : ""}`}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setSelectedP1(item.title);
                                                                            }}
                                                                        >
                                                                            {selectedP1 === item.title && <div><FaCircleCheck className='icon' color='Green' size="1.1rem" /></div>}
                                                                            <div>{item.title}</div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }

                                                        {showSecondGroup &&
                                                            <div className="group second">
                                                                <div className='title'>
                                                                    {propTitles.title2} : {selectedP2}
                                                                </div>
                                                                <div className='itemsSelect'>
                                                                    {secondLevelData.map((item) => (
                                                                        <div
                                                                            key={item.id}
                                                                            className={`itemSelect${selectedP2 === item.title ? " choice second" : ""}`}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setSelectedP2(item.title);
                                                                            }}
                                                                        >
                                                                            {selectedP2 === item.title && <div><FaCircleCheck className='icon' color='Green' size="1.1rem" /></div>}
                                                                            <div>{item.title}</div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {hasDescription && (
                                            <div
                                                className="description"
                                                style={{
                                                    whiteSpace: 'pre-wrap',
                                                    wordBreak: 'break-word',
                                                    lineHeight: '1.8'
                                                }}
                                            >
                                                {commodity.description}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="price-add-basket" style={{ flexShrink: 0 }}>
                                <div className="wrraper-price">
                                    <div className="btn_wrraper">
                                        <div
                                            className={`btn_add ${(!current || current.stock === undefined || current.stock <= 0) ? 'disabled' : ''}`}
                                            style={(!current || current.stock === undefined || current.stock <= 0) ? {
                                                backgroundColor: '#ccc',
                                                color: '#777',
                                                cursor: 'not-allowed',
                                                pointerEvents: 'none'
                                            } : {}}
                                            onClick={() => {
                                                if (!current || current.stock === undefined || current.stock <= 0) return;
                                                if (!current.price) {
                                                    toast.warning("لطفاً مشخصات کالا را کامل انتخاب کنید", {
                                                        position: "top-right", autoClose: 1000, theme: "light", rtl: "true"
                                                    });
                                                    return;
                                                }
                                                handleIncrement();
                                            }}>
                                            افزودن به سبد خرید
                                        </div>
                                    </div>

                                    {current && current.rawPrice > 0 && (
                                        <div className="inventory-status" style={{
                                            position: 'absolute',
                                            right: '178px',
                                            top: '20%',
                                            transform: 'translateY(-50%)',
                                            fontSize: '1rem',
                                            fontFamily: 'vazir',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {current.stock > 0 ? (
                                                <span style={{ color: 'green' }}>موجودی: {current.stock.toLocaleString('fa-IR')}</span>
                                            ) : (
                                                <span style={{ color: 'red' }}>ناموجود</span>
                                            )}
                                        </div>
                                    )}

                                    <div className="discount-percent">
                                        <div className='digit'>{Math.round(commodity.discount_percent, 0).toLocaleString('fa-IR')}%</div>
                                        <div className='title'>تخفیف</div>
                                    </div>

                                    {commodity.discount_percent > 0 &&
                                        <div className="price-discount">
                                            {current.price ? current.price.toLocaleString('fa-IR') : "---"} تومان
                                        </div>
                                    }

                                    <div className={`price-orginal`}>
                                        {current.rawPrice ?
                                            Math.round(current.rawPrice - ((current.rawPrice * commodity.discount_percent) / 100)).toLocaleString('fa-IR')
                                            : "---"
                                        } تومان
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Modal>}
        </div>
    );
}

export default ShopBasketAdd;
